import { apiRequest } from './apiClient';

export const fetchDashboard = async () => (await apiRequest('/dashboard')).data;
